import React from 'react'

import { useNotification } from '@notification/context/NotificationContext'
import { TYPE_TO_COLOR } from '@model/constants'

import css from './Toast.module.css'


export const Toast: React.FC = () => {
  const { toasts, removeToast } = useNotification()

  return (
    <>
      {['top-right', 'bottom-right'].map((position) => (
        <div
          key={position}
          className={css['toast-container'] + ' ' + css[`toast-container--${position}`]}
        >
          {toasts.filter(t => (t.position ?? 'top-right') === position).map(toast => (
            <div
              key={toast.id}
              className={css.toast + ' ' + css[`toast--${toast.type}`]}
              style={{ background: TYPE_TO_COLOR[toast.type] }}
            >
              <div className={css['toast__header']}>
                <span className={css['toast__title']}>{toast.title}</span>
                <button className={css['toast__close']} onClick={() => removeToast(toast.id)}>&times;</button>
              </div>
              <div className={css['toast__message']}>{toast.message}</div>
            </div>
          ))}
        </div>
      ))}
    </>
  )
} 